
















































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import ApiFactory from "@/api/ApiFactory";
import { PerformanceChartDataDto } from "@/api/ClientPortalApiClient";
import { UserStore, LoadingSpinnerService } from "@/store";
@Component
export default class FundTotalPerformanceChart extends Vue {
  @Prop() id: number | undefined;

  private performanceChartData: PerformanceChartDataDto | null = null;
  private showIndividualFunds: boolean = false;
  private noData: boolean = false;
  private perfChartOptions = {
    legend: {
      position: "bottom"
    },

    padding: {
      top: 50,
      right: 10,
      bottom: 50,
      left: 50
    },

    scales: {
      x: {
        display: true,
        title: {
          display: true,
          text: "Month"
        }
      },
      y: {
        display: true,
        title: {
          display: true,
          text: "Value"
        }
      }
    },
    hAxis: {
      format: "MMM YY"
    },
    vAxis: {
      format: "short"
    },
    dataLabels: {
      display: true
    },
    chartArea: {
      top: 20,
      left: 80,
      right: 20
    },
    animation: {
      duration: 500,
      startup: true,
      easing: "out"
    }
  };

  async mounted() {
    await this.getFundPerformance();
  }

  private async getFundPerformance() {
    if (!this.id) throw new Error("Type id not valid");
    const api = ApiFactory.CreateDataClient();
    try {
      const perfData = await api.funds_GetTotalFundValuePerformance(
        UserStore.profileId,
        12,
        this.id
      );
      if (perfData) {
        this.performanceChartData = perfData;
      } else {
        this.noData = true;
      }
    } catch (e) {
      this.noData = true;
    }
  }
}
